import { useTranslation } from 'react-i18next'
import style from "../../../sass/pages/shipment/shipment.module.scss";
import { useRef } from 'react';
import { pushAlert } from '../../alerts/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectShipmentSettingInvoiceTypeStatus, setInvoiceType, selectShipmentSettingInvoiceTypeError, selectShipmentOwnInvoiceStatus, selectShipmentOwnInvoiceError, sendOwnInvoice, selectShipment } from '../shipmentSlice';
import { useEffect } from 'react';
import WhiteSpinner from '../../../components/loaders/WhiteSpinner';

const Invoice = ({ shipmentID, fileName, isPonyExpressInvoice }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()


    const fileInputRef = useRef(null)

    const settingInvoiceStatus = useSelector(selectShipmentSettingInvoiceTypeStatus)
    const settingInvoiceError = useSelector(selectShipmentSettingInvoiceTypeError)
    const sendingInvoiceError = useSelector(selectShipmentOwnInvoiceError)
    const sendingInvoiceStatus = useSelector(selectShipmentOwnInvoiceStatus)
    const shipment = useSelector(selectShipment)

    const handleInvoiceTypeChange = (invoiceType) => {
        if(!shipment) return

        if (isPonyExpressInvoice && invoiceType === "pony") return
        if (!isPonyExpressInvoice && invoiceType === "own") return

        if(shipment && shipment.blocked) {
            dispatch(pushAlert({
                type: "danger",
                message: t("shipment.info.package_sent_to_akad"),
                delay: 2000,
            }))
            return
        }

        dispatch(setInvoiceType({ shipmentID, invoiceType }))
    }

    const handleInputChange = () => {
        let files = fileInputRef.current.files
        if (files.length <= 0) {
            return
        }

        let file = files[0]
        dispatch(sendOwnInvoice({ shipmentID, file }))
    }

    useEffect(() => {
        if(sendingInvoiceStatus === "fulfilled") {
            fileInputRef.current.value = ""
            dispatch(pushAlert({
                type: "success",
                message: t("shipment.additional_files.file_successfully_uploaded"),
                delay: 2000,
            }))
        }
    }, [dispatch, sendingInvoiceStatus])

    useEffect(() => {
        if (settingInvoiceError) {
            dispatch(pushAlert({
                type: "danger",
                message: t(settingInvoiceError),
                delay: 2000,
            }))
        }
    }, [settingInvoiceError, dispatch])

    useEffect(() => {
        if (sendingInvoiceError) {
            dispatch(pushAlert({
                type: "danger",
                message: t(sendingInvoiceError),
                delay: 2000,
            }))
        }
    }, [sendingInvoiceError, dispatch])

    return (
        <div className='flex flex-col'>
                <div className='flex flex-wrap mb-3'>
                    <div
                        className="border px-2 py-1 font-light text-xs sm:text-base"
                        style={{
                            background: isPonyExpressInvoice ? "#059669" : "white",
                            color: isPonyExpressInvoice ? "white" : "",                            
                        cursor: shipment && shipment.blocked ? "not-allowed": "pointer"
                        }}
                        onClick={() => handleInvoiceTypeChange("pony")}
                    >
                        <span className='mr-2'>
                            {t("shipment.additional_files.registrate_invoice_using_pony_express")}
                        </span>
                        {
                            settingInvoiceStatus === "pending" &&
                            <WhiteSpinner width="15px" height="15px"/>
                        }
                    </div>
                    <div
                        className="border px-2 py-1 font-light text-xs sm:text-base"
                        style={{
                            background: isPonyExpressInvoice ? "white" : "#059669",
                            color: isPonyExpressInvoice ? "black" : "white",
                            cursor: shipment && shipment.blocked ? "not-allowed": "pointer"
                        }}
                        onClick={() => handleInvoiceTypeChange("own")}
                    >
                        <span className='mr-2'>
                            {t("shipment.additional_files.registrate_own_invoice")}
                        </span>
                        {
                            settingInvoiceStatus === "pending" &&
                            <WhiteSpinner width="15px" height="15px"/>
                        }
                    </div>
                </div>
            {
                !isPonyExpressInvoice &&
                <div className='flex justify-left items-center flex-wrap gap-x-4 gap-y-2'>
                    {/* Headline */}
                    {fileName &&
                        <span className="text-left text-xs sm:text-basic font-medium">
                            {t("shipment.additional_files.own_invoice_pinned")}: {fileName}
                        </span>
                    }
                    {/* file input */}
                    {
                        shipment && !shipment.blocked &&
                        <div className='w-fit text-left mt' style={{ minWidth: "300px", maxWidth: "300px" }}>
                            <label
                                htmlFor="ownInvoiceDocument"
                                className={`${style.btn} ${style["btn-primary"]} font-normal w-full text-sm text-center`}
                                style={{
                                    display: "inline-block",
                                    minWidth: "220px",
                                    maxWidth: "220px",
                                    padding: "3px 10px"
                                }}
                            >
                                {
                                    sendingInvoiceStatus === "pending" ?
                                        (
                                            <WhiteSpinner />
                                        ) :
                                        (
                                            fileName ?
                                                t("shipment.additional_files.upload_new_pdf_file") :
                                                t("shipment.additional_files.upload_pdf_file")
                                        )
                                }
                            </label>
                            <input
                                style={{ visibility: "hidden", width: 0, height: 0 }}
                                id="ownInvoiceDocument"
                                type="file"
                                accept="application/pdf"
                                ref={fileInputRef}
                                onChange={handleInputChange}
                            />
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default Invoice